<template>
  <div class="uk-flex full-width">
    <div class="uk-column-1-1 uk-flex uk-flex-column full-width">
      <form class="uk-flex uk-flex-column">
        <form-group
          v-if="
            (!formFields.title.uiModeHidden ||
              (formFields.title.uiModeHidden && uiMode !== formFields.title.uiModeHidden)) &&
            ['review', 'readOnly', 'new', 'edit'].includes(mode)
          "
          class="uk-margin uk-margin-remove-top uk-width-1-1"
          :class="{ error: v$.form.title.$error }"
          :validator="v$.form.title"
        >
          <span v-if="mode === 'readOnly' && getDisputedCitation" class="uk-text-bold"
            >Click link to show Debate</span
          >
          <span v-else class="uk-text-bold">Label</span>
          <span class="uk-inline full-width uk-flex uk-flex-middle">
            <span
              v-if="formFields.title.icon"
              :uk-icon="`icon: ${formFields.title.icon}; ratio: 1.4`"
            ></span>
            <span
              v-if="['review', 'readOnly'].includes(mode) && !getDisputedCitation"
              class="head-title-background-field"
              >{{ form.title }}</span
            >
            <span
              v-else-if="['readOnly'].includes(mode) && getDisputedCitation"
              class="head-title-background-field"
            >
              <a
                :href="getDisputedCitation ? getDebateHref : form.url"
                target="_blank"
                class="ellipsis-link"
                >{{ getDisputedCitation ? form.title : form.url }}</a
              ></span
            >
            <div class="uk-width-1-1 uk-position-relative" v-else>
              <input
                class="uk-input label-focus-field inputField"
                :type="formFields.title.type"
                :placeholder="formFields.title.placeholder"
                v-model="form.title"
                required
                maxlength="80"
                @input="(v$.form.title.$touch(), updateCounter())"
              />
              <span class="uk-position-absolute uk-flex uk-flex-right" style="right: 0">
                <span class="uk-text-small">Characters left:&nbsp;</span>
                <span id="counter" class="counter uk-text-small">80</span>
              </span>
            </div>
            <span
              v-if="['review', 'readOnly', 'edit'].includes(mode)"
              uk-icon="icon: copy"
              class="uk-flex-right uk-icon copy-icon-effect"
              style="cursor: pointer"
              :uk-tooltip="'Copy to Clipboard'"
              @click="copyText(form.title)"
            />
          </span>
        </form-group>
        <form-group
          v-if="
            !formFields.url.uiModeHidden ||
            (formFields.url.uiModeHidden && uiMode !== formFields.url.uiModeHidden)
          "
          class="uk-margin-top uk-width-1-1"
          :class="{ error: v$.form.url.$error }"
          :validator="v$.form.url"
        >
          <span class="uk-text-bold">Source</span>
          <span class="uk-inline full-width uk-flex uk-flex-middle">
            <template v-if="['review', 'readOnly'].includes(mode)">
              <div class="head-title-background-field-data uk-flex">
                <div
                  v-if="
                    citation.content ||
                    citation.url.endsWith('.txt') ||
                    citation.url.endsWith('.docx')
                  "
                  class="uk-flex uk-width-1-1"
                  @click="previewDataShow()"
                >
                  <span
                    v-if="
                      formFields.url.icon &&
                      ['review', 'readOnly'].includes(mode) &&
                      (citation.url.endsWith('.txt') || citation.url.endsWith('.docx'))
                    "
                    :uk-icon="`icon: folder; ratio: 1.4`"
                    class="view-cite-icons"
                  ></span>
                  <span
                    v-else-if="
                      formFields.url.icon &&
                      ['review', 'readOnly'].includes(mode) &&
                      citation.content &&
                      form.file.type === 'text'
                    "
                    :uk-icon="`icon: file-text; ratio: 1.4`"
                    class="view-cite-icons"
                  ></span>
                  <textarea
                    v-if="form.file.type === 'text'"
                    style="height: 145px"
                    class="uk-textarea uk-width-1-1 focus-field past-textarea"
                    type="text"
                    disabled
                    ref="form_text"
                    v-model="form['file']['data']"
                  />
                  <span v-else class="fileLookLink ellipsis-link">{{ form.url }}</span>
                </div>
                <a
                  v-else-if="form.file.type === 'cite'"
                  :href="form.url"
                  target="_blank"
                  class="ellipsis-link"
                >
                  <img
                    src="/icons/debate-library.svg"
                    height="26px"
                    width="26px"
                    alt=""
                    class="import-icon-styles-cite"
                  />{{ form.url }}
                </a>
                <a v-else :href="form.url" target="_blank" class="ellipsis-link">
                  <span :uk-icon="`icon: ${formFields.url.icon}; ratio: 1.4`"></span>
                  {{ form.url }}</a
                >
              </div>
            </template>
            <template v-else>
              <span
                v-if="error.file !== ''"
                style="color: red; font-size: var(--global-font-size); font-style: italic"
                >{{ error.file }}
              </span>
              <CustomImport
                @handleDocumentType="handleDocumentType"
                :form_prop.sync="form"
                :citeDebate="true"
                :showOr="false"
                :editMode="['edit'].includes(mode) && editModeData"
              />
            </template>
            <span
              v-if="['review', 'readOnly'].includes(mode) && form.file.type === 'url'"
              uk-icon="icon: copy"
              class="uk-flex-right uk-icon copy-icon-effect"
              style="cursor: pointer"
              :uk-tooltip="'Copy to Clipboard'"
              @click="copyText(getDisputedCitation ? form.title : form.url)"
            />
          </span>
          <small v-if="form.isInternal">* This is an Internal Link</small>
        </form-group>
      </form>
    </div>
    <div uk-modal ref="previewModal">
      <BasicModal
        style="width: 40%"
        class="preview-modal-box"
        :heading="{ title: form.title, color: 'white', buttonSave: plainTexts }"
        :bottomLine="false"
        @savetext="updatePreviewText(citation, previewData)"
      >
        <ResourceLoadStatus
          class="text-preview-edit-area"
          v-if="previewDataLoad"
          :loading="previewDataLoad"
        />
        <div v-else>
          <textarea
            v-if="plainTexts"
            class="uk-textarea text-preview-edit-area"
            v-model="form['file']['data']"
          ></textarea>
          <p v-else style="white-space: pre-wrap">{{ previewData }}</p>
        </div>
      </BasicModal>
    </div>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import DocumentType from '@/assets/js/enum/DocumentType';
import LoadingStatus from '@/assets/js/enum/LoadingStatus';
import ResourceLoadStatus from '@/components/general/ResourceLoadStatus';
import CustomImport from '@/components/form/CustomImport';
import { EventBus } from '@/assets/js/event-bus';
import { required, url } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapState, mapGetters, mapActions } from 'vuex';
import BasicModal from '@/components/display/general/BasicModal';
import UIkit from 'uikit';
const internalLinkRegex = new RegExp(`${window.location.origin}/#/document-details/[a-z0-9]{24}`);

export default {
  name: 'CitationForm',
  setup() {
    const form = reactive({
      url: '',
      title: '',
      isInternal: false,
      file: '',
    });

    const rules = computed(() => ({
      form: {
        url: { required },
        title: { required },
      },
    }));

    const v$ = useVuelidate(rules, { form });

    return { form, v$: v$.value };
  },

  props: {
    citation: Object,
    mode: String, // new | edit | review | readOnly
  },

  model: {
    prop: 'document',
  },

  components: {
    CustomImport,
    BasicModal,
    ResourceLoadStatus,
  },

  data() {
    return {
      internalMode: '',
      previewData: '',
      previewDataLoad: false,
      dataStatus: '',
      plainTexts: false,
      editModeData: true,
      copyIconSuccess: false,
      formFields: {
        url: {
          type: 'url',
          icon: 'link',
          placeholder: 'Enter the external URL',
        },

        title: {
          type: 'text',
          placeholder: 'Enter a descriptive title',
        },
      },
      fileLoading: false,
      error: {
        discussiontitle: '',
        author: '',
        date: '',
        file: '',
      },
    };
  },

  computed: {
    UIkit() {
      return UIkit;
    },
    LoadingStatus() {
      return LoadingStatus;
    },
    ...mapState(['documentData', 'userData', 'publicView', 'currentTeam']),

    ...mapGetters(['publicLinkID']),

    getDisputedCitation() {
      if (
        this.userData?.id !== this.citation?.disputedBy &&
        this.citation?.disputed &&
        this.citation?.childPublished
      ) {
        return true;
      } else if (this.userData?.id === this.citation?.disputedBy && this.citation?.disputed) {
        return true;
      } else return false;
    },
    /**
     * Return link for button "Open Full Annotations" according to public or private access
     */
    getDebateHref() {
      const baseURL = `${window.location.origin}/#`;
      if (this.publicView)
        return `${baseURL}${this.$router.routesMap.Debate(this.citation?.document?._id)}?linkId=${this.publicLinkID}`;
      else return `${baseURL}${this.$router.routesMap.Debate(this.citation?.document?._id)}`;
    },
  },

  watch: {
    /**
     * Watch for citation updates and set values in form accordingly
     */
    citation: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) {
          this.form.title = '';
          this.form.url = '';
        } else {
          this.form.title = val.title;
          this.form.url = val.url;
          if (url(val.url) && !val.url.includes('debate')) {
            this.form.file = {
              name: val.url,
              data: val.url,
              type: 'url',
            };
          } else if (val.url.includes('debate')) {
            this.form.file = {
              name: val.url,
              data: val.url,
              type: 'cite',
            };
          } else if (val.url.endsWith('.txt') || val.url.endsWith('.docx')) {
            this.form.file = {
              name: val.url,
              data: val.url,
              type: 'file',
            };
          } else {
            this.form.file = {
              name: val.url,
              data: val.url,
              type: 'text',
            };
          }
        }

        this.savingStatus = LoadingStatus.NONE;
      },
    },
    'form.file.type': {
      immediate: true,
      handler() {
        this.checkExpandShowButton();
      },
    },
    mode: {
      immediate: true,
      handler() {
        this.checkExpandShowButton();
      },
    },
    /**
     * Watch for form.url field updates and validate internal or external link
     */
    'form.url': {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) return;
        const [linkRef, linkTitleQuery] = val.split('?');

        const linkBase = internalLinkRegex.exec(linkRef);
        this.form.isInternal = !!(linkBase && linkBase[0]);

        if (linkBase) {
          const [, linkTitle] =
            linkTitleQuery && val.match(/\?title=/)
              ? linkTitleQuery.split('=')
              : [undefined, undefined];
          this.form.title = decodeURIComponent(linkTitle);
        }
      },
    },

    'v$.$invalid': {
      immediate: true,
      handler(value) {
        this.$emit('invalidated', value);
      },
    },
  },
  mounted() {
    this.updateCounter();
    EventBus.on('citation.preview', this.previewDataShow);
    EventBus.on('citation.modal.hide', this.copyIconSuccessHide);
    EventBus.on('citation.edit.modal.hide', this.editModalHide);
  },
  beforeUnmount() {
    EventBus.off('citation.preview', this.previewDataShow);
    EventBus.off('citation.modal.hide', this.copyIconSuccessHide);
    EventBus.off('citation.edit.modal.hide', this.editModalHide);
  },
  methods: {
    /**
     * Submit form
     */
    ...mapActions(['viewCitationText']),
    async submitForm() {
      this.v$.form.$touch();
      if (this.v$.form.$pending || this.v$.form.$error) return;

      if (this.mode === 'new') {
        await this.saveNewCitation();
      } else if (this.mode === 'edit' || this.internalMode === 'edit') {
        await this.editCitation();
      }

      if (this.internalMode === 'edit') this.internalMode = '';
    },
    checkExpandShowButton() {
      if (this.form.file.type !== 'cite' && this.form.file.type !== 'url' && this.mode !== 'new') {
        this.$emit('expandShowButton', true);
      } else {
        this.$emit('expandShowButton', false);
      }
    },
    updatePreviewText(cite, preview) {
      this.form.plain_text_content = preview;
      this.form.url = preview;
      this.form.file = '';
      const data = {
        ...this.form,
      };
      this.editModeData = true;
      UIkit.modal(this.$refs.previewModal).hide();
      EventBus.emit('citation.toUpdate', data);
    },
    // todo loader
    async previewDataShow() {
      UIkit.modal(this.$refs.previewModal, { center: true, stack: true }).show();
      this.dataStatus = LoadingStatus.LOADING;
      this.previewData = '';
      this.previewDataLoad = true;
      let res = await this.viewCitationText({ citationId: this.citation._id });
      if (res.url.endsWith('.txt') || res.url.endsWith('.docx')) {
        this.plainTexts = false;
      } else if (this.mode === 'edit' && res.content) {
        this.plainTexts = true;
      } else {
        this.plainTexts = false;
      }
      this.previewData = res.content;
      this.previewDataLoad = false;
      this.dataStatus = LoadingStatus.NONE;
    },
    copyText(text) {
      this.copyIconSuccess = true;
      navigator.clipboard.writeText(text);
    },
    copyIconSuccessHide(val) {
      this.copyIconSuccess = val;
    },
    resetForm() {
      this.v$.$reset();
      this.form.url = '';
      this.form.title = '';
      this.form.file = {};
      this.form.isInternal = false;
    },
    setCitationData(citationData) {
      this.form.title = citationData.title;
      this.form.url = citationData.url;

      if (citationData.url) {
        if (url(citationData.url)) {
          this.form.file = {
            name: citationData.url,
            data: citationData.url,
            type: 'url',
          };
        } else if (citationData.url.includes('/debate/')) {
          this.form.file = {
            name: citationData.url,
            data: citationData.url,
            type: 'cite',
          };
        } else if (citationData.url.endsWith('.txt') || citationData.url.endsWith('.docx')) {
          this.form.file = {
            name: citationData.url,
            data: citationData.url,
            type: 'file',
          };
        } else {
          this.form.file = {
            name: citationData.url,
            data: citationData.fileData,
            type: 'text',
          };
        }
      }
    },
    handleDocumentType(value) {
      this.form.file = {};
      this.form.url = '';
      this.editModeData = false;
      this.form.date = new Date().toISOString().slice(0, 10);
      if (value !== 'custom' && this.form.file.name) {
        this.reset();
        this.form.documentType = value;
      }
    },
    editModalHide(val) {
      this.updateCounter();
      this.editModeData = val;
    },
    /**
     * Emit event to save a new citation
     */
    async saveNewCitation() {
      const documentType = !this.form.isInternal ? DocumentType.ARTICLE : undefined;

      const newCitation = {
        documentType,
        ...this.form,
      };

      if (this.form.isInternal) {
        const documentIdRegEx = new RegExp('[a-z0-9]{24}');
        newCitation.documentId = documentIdRegEx.exec(this.form.url)[0];
      }

      EventBus.emit('citation.toAddNew', newCitation);
    },

    /**
     * Emit event to edit a citation
     */
    async editCitation() {
      this.form.plain_text_content = '';
      const data = {
        ...this.form,
      };
      this.editModeData = true;
      EventBus.emit('citation.toUpdate', data);
    },
    updateCounter() {
      if (this.mode === 'edit' || this.mode === 'new') {
        var maxLength = 80;
        var input = this.form.title;
        var counter = document.getElementById('counter');
        var remaining = maxLength - input.length;

        if (remaining === 0) {
          counter.classList.add('zero');
        } else {
          counter.classList.remove('zero');
        }
        counter.textContent = remaining;
      }
    },
  },
};
</script>
<style lang="sass">
.view-cite-icons
  align-self: center !important
  margin: 5px 4px auto 0 !important
  cursor: pointer !important
.ellipsis-link
  display: -webkit-box
  overflow: hidden
  -webkit-line-clamp: 1
  -webkit-box-orient: vertical
  width: 99%
.uk-input
  border: 2px solid #516d79 !important
.fileLookLink
  color: #64a3bd
  text-decoration: underline
  cursor: pointer
.text-preview-edit-area
  min-height: 60vh
.head-title-background-field
  border: 2px solid #516d79
  width: 98%
  border-radius: 5px
  padding-left: 7px
  background: #f3f3f3
  &-data
    border: 2px solid #516d79
    width: 100%
    border-radius: 5px
    padding-left: 7px
    background: #f3f3f3

.copy-icon-effect
  margin-left: 3px !important
  &:active
    color: blue
    transform: scale(1.3)
.preview-modal-box
  left: 28%
  padding: 0
  min-width: 860px
  position: absolute !important
.char-left-mess
  position: absolute
  right: 0
.form-error
  font-size: $global-font-size
.expand-icon-preview
  float: right
  padding-right: 20px !important
  margin-top: 3px !important
  color: white !important
</style>
<style>
.zero {
  color: red;
}
</style>
